export enum ConversationEndpoints {
   FetchThreadsByUser = '/message-threads/by-user/accountType/:accountType',
   UpdateArchivedDate = '/message-threads/archived-date/:threadId',
   FetchExistingBetweenTwoUsers = '/message-threads/between-users/:receiverId/:receiverAccountType/:senderAccountType',
   UpdateLastMessageReadDate = '/message-threads/last-message-read-date/:threadId',
   FetchForNotifications = '/message-threads/has-unread-messages'
}
